/**
 * @file    AuthContext.css
 * @author  David Courtis <david@distributive.network>
 * @date    Feb. 2024
 */

#idleModal {
  max-height: 70vh;
}

#idleModal section {
  font-size: 1em;
  padding: 10px 16px 0;
  color: black;
}

#idleModal p {
  padding: 0 0 1em;
}

#idleModal .idleModalButtons {
  display: flex;
  gap: 20px;
}

@media only screen and (max-width: 500px) {
  #idleModal section {
    padding: 0;
  }
}
